import { render, staticRenderFns } from "./OtherPreview.vue?vue&type=template&id=6309a21a&scoped=true"
import script from "./OtherPreview.vue?vue&type=script&lang=js"
export * from "./OtherPreview.vue?vue&type=script&lang=js"
import style0 from "./OtherPreview.vue?vue&type=style&index=0&id=6309a21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309a21a",
  null
  
)

export default component.exports